import { cva } from 'class-variance-authority';

export const variants = cva(
	[
		'border-[1px]',
		'border-transparent',
		'relative',
		'active:transition-none',
		'disabled:cursor-default',
		'disabled:pointer-events-none',
		'disabled:opacity-30',
	],
	{
		variants: {
			variant: {
				primary: ['bg-primary-500', 'text-dark-950', 'hover:bg-primary-300', 'active:text-dark-950/50'],
				secondary: ['bg-secondary-500', 'text-dark-950', 'hover:bg-secondary-300', 'active:text-dark-950/50'],
				tertiary: ['bg-dark-800', 'text-white', 'hover:bg-dark-600', 'active:text-white-500/50'],
				success: ['bg-success-500', 'text-dark-950', 'hover:bg-success-300', 'active:text-dark-950/50'],
				danger: ['bg-danger-500', 'text-dark-950', 'hover:bg-danger-300', 'active:text-dark-950/50'],
				warning: ['bg-warning-500', 'text-dark-950', 'hover:bg-warning-300', 'active:text-dark-950/50'],
				white: ['bg-white', 'text-dark-950', 'hover:bg-dark-200', 'active:text-dark-950/50'],
			},
			size: {
				sm: ['text-[12px]', 'p-[1px_16px]', 'min-h-[24px]', 'rounded-[2px]'],
				md: ['text-[14px]', 'p-[2px_16px]', 'min-h-[32px]', 'rounded-[2px]'],
				lg: ['text-[16px]', 'p-[5px_16px]', 'min-h-[40px]', 'rounded-[2px]'],
				xl: ['text-[18px]', 'p-[8px_16px]', 'min-h-[48px]', 'rounded-[2px]'],
			},
			disabled: { true: '', false: '' },
			fullwidth: { true: 'w-full', false: '' },
			outline: {
				true: ['font-medium', 'bg-transparent', 'hover:bg-transparent'],
				false: ['font-semibold', 'border-b-dark-950/20', 'transition-colors'],
			},
		},
		compoundVariants: [
			{
				variant: 'primary',
				outline: true,
				className: [
					'border-primary-500',
					'text-primary-500',
					'hover:border-primary-500/70',
					'hover:text-primary-500/70',
					'active:border-primary-500/50',
					'active:text-primary-500/50',
				],
			},
			{
				variant: 'secondary',
				outline: true,
				className: [
					'border-secondary-500',
					'text-secondary-500',
					'hover:border-secondary-500/70',
					'hover:text-secondary-500/70',
					'active:border-secondary-500/50',
					'active:text-secondary-500/50',
				],
			},
			{
				variant: 'tertiary',
				outline: true,
				className: [
					'border-white',
					'text-white',
					'hover:border-white/70',
					'hover:text-white/70',
					'active:border-white/50',
					'active:text-white/50',
				],
			},
			{
				variant: 'success',
				outline: true,
				className: [
					'border-success-500',
					'text-success-500',
					'hover:border-success-500/70',
					'hover:text-success-500/70',
					'active:border-success-500/50',
					'active:text-success-500/50',
				],
			},
			{
				variant: 'danger',
				outline: true,
				className: [
					'border-danger-500',
					'text-danger-500',
					'hover:border-danger-500/70',
					'hover:text-danger-500/70',
					'active:border-danger-500/50',
					'active:text-danger-500/50',
				],
			},
			{
				variant: 'warning',
				outline: true,
				className: [
					'border-warning-500',
					'text-warning-500',
					'hover:border-warning-500/70',
					'hover:text-warning-500/70',
					'active:border-warning-500/50',
					'active:text-warning-500/50',
				],
			},
			{
				variant: 'white',
				outline: true,
				className: [
					'border-white-500',
					'text-warning-500',
					'hover:border-white/70',
					'hover:text-white/70',
					'active:border-white/50',
					'active:text-white/50',
				],
			},
		],
		defaultVariants: {
			variant: 'primary',
			size: 'lg',
			fullwidth: false,
			outline: false,
			disabled: false,
		},
	},
);
